import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QBankStructureCVModalAction,
  useQBankStructureCVModal,
} from '@exam-management/qbank-structure-cv';
import { useNavigateModals } from '@exam-management/router';
import { type UserRow } from '@exam-management/user-management';
import { useAuth } from '@shared/auth';
import {
  Box,
  DeleteOutlineIcon,
  IconButton,
  ManageAccountsOutlinedIcon,
  Menu,
  MenuItem,
  MoreVertIcon,
  type BoxProps,
} from '@shared/components';
import { WithPermission } from '@shared/permissions';
import { useState } from 'react';

interface MoreActionButtonProps extends BoxProps {
  createdBy: string;
  structureId: string;
  userDetails: UserRow;
}
// TODO: Promote to container ?
export function MoreActionButton(props: Readonly<MoreActionButtonProps>) {
  const { open: openRemoveModal } = useNavigateModals('/confirm-remove-user-from-qbank-structure');
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { structureId, createdBy, userDetails, ...restProps } = props;

  const { userProfile } = useAuth();
  // TODO: integrate with owner id checking
  const { setAction, setEditUserCVDetails } = useQBankStructureCVModal();

  const isOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleVisibilitySettings = () => {
    setAction(QBankStructureCVModalAction.EDIT_CONTENT_VISIBILITY_OF_MEMBER);
    setEditUserCVDetails(userDetails);
    handleClose();
  };

  const handleRemoveUser = () => {
    openRemoveModal({ structureId, userId: userDetails.userId });
    handleClose();
  };

  const isQBankStructureOwner = createdBy === userDetails?.userId;
  const isDisabledAction = isQBankStructureOwner || userDetails.userId === userProfile?.id;

  return (
    <Box mx='auto' {...restProps}>
      <IconButton
        aria-label='more'
        id='long-button'
        aria-controls={isOpen ? 'long-menu' : undefined}
        aria-expanded={isOpen ? 'true' : undefined}
        aria-haspopup='true'
        onClick={handleClick}
        disabled={isDisabledAction}
      >
        <MoreVertIcon fontSize='medium' />
      </IconButton>
      <Menu
        id='long-menu'
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        variant='menu'
        sx={(theme) => ({
          mt: theme.spacing(1),
          '& .MuiMenuItem-root': {
            minWidth: 184,
            gap: theme.spacing(1),
          },
        })}
      >
        <MenuItem onClick={handleVisibilitySettings}>
          <ManageAccountsOutlinedIcon />
          Visibility Settings
        </MenuItem>
        <WithPermission requiredPermission={APP_PERMISSIONS.QBANK.SETTING.UPDATE}>
          <MenuItem
            onClick={handleRemoveUser}
            sx={(theme) => ({ color: theme.palette.error.main })}
          >
            <DeleteOutlineIcon />
            Remove User
          </MenuItem>
        </WithPermission>
      </Menu>
    </Box>
  );
}
